import {Tone} from "../../../components/kit";

/** Tipos de ausencia en español (#13877): el enum del API llega en inglés («HOLIDAY»). */
export const VACATION_TYPE_LABELS: Record<string, string> = {
	HOLIDAY: "Vacaciones",
	SICK_LEAVE: "Baja médica",
	PATERNITY_LEAVE: "Permiso por nacimiento",
	ERTE: "ERTE",
	ERTE_50: "ERTE al 50 %",
	GIFT: "Día libre",
	MOVING: "Mudanza",
	WEDDING: "Boda",
	UNPAID_LEAVE: "Permiso sin sueldo",
	FAMILIAR_HOSPITALIZATION: "Hospitalización de un familiar",
};

/** Estado de una solicitud de ausencia, con el tono de su etiqueta. */
export const VACATION_STATE: Record<string, { label: string, tone: Tone }> = {
	PENDING: {label: "Pendiente", tone: "warning"},
	ACCEPTED: {label: "Aceptada", tone: "success"},
	REJECTED: {label: "Rechazada", tone: "error"},
};

export const vacationTypeLabel = (type?: string) => type ? VACATION_TYPE_LABELS[type] || type : "";
